import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import {ListUserGroupResponse, UserGroup} from "../http/protocol";


export class UserGroupService extends AbstractAdminEntityService<UserGroup, ListUserGroupResponse>   {

    constructor(http : HttpService) {
        super("/user-group", http)
    }

    listPermissionCategories() : Promise<string[]> {

        return this.http.get<string[]>(this.entityPath + "/list-permission-categories");

    }
    listPermissionDescriptionCategory() : Promise<object> {

        return this.http.get<object>(this.entityPath + "/list-permission-description-category");

    }
    fetchUserGroup(nameId : string): Promise<UserGroup> {
       return this.http.get<UserGroup>("/user-group/" + nameId);
    }
    updateGroup(userGroup : UserGroup) : Promise<UserGroup> {
        return this.http.post<UserGroup, UserGroup>( this.entityPath + "/update", userGroup);
    }



}